<template>
    <span class="items-count">
        <span class="mr-1">
            <span class="value">{{ slides.length }}</span>
            {{ slidesLengthPostfix }}
        </span>

        <span>
            <span class="value">{{ activeWells.length }}</span>
            {{ $translate('wells').toLowerCase() }}
        </span>
    </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { INSTRUMENT_TYPE } from '../../../business/const'

export default {
    name: 'ItemsCount',
    props: {
        slides: {
            type: Array,
            required: true
        },
        wells: {
            type: Array,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        activeWells() {
            return this.wells.filter(well => !!well)
        },
        instrumentType() {
            return this.getSelectedInstrument.type
        },
        slidesLengthPostfix() {
            switch (this.instrumentType) {
                case INSTRUMENT_TYPE.GERI:
                    return this.$translate('chambers').toLowerCase()
                case INSTRUMENT_TYPE.MIRI:
                    return this.$translate('compartments').toLowerCase()
                default:
                    return this.$translate('slides').toLowerCase()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.items-count {
    font-size: 10pt;
    white-space: nowrap;

    .value {
        color: $light-3;
    }
}
</style>
